@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <h3>Cash up</h3>
    @if (id == '0') {
      <div class="surface-card p-4 shadow-2 border-round" style="margin-top:5px;">
        <div style="margin-bottom:20px;">
          <div style="float: left; width:50px;">
            &nbsp;
          </div>
          <div style="width:20%;float: left;font-size:20px;font-weight:bold;">
            Payment Name
          </div>
          <div style="width:20%;float: left;font-size:20px;font-weight:bold;">
            Total Expected
          </div>
          <div style="width:20%;float: left;font-size:20px;font-weight:bold;">
            Total Actual
          </div>
          <div style="width:20%;float: left;font-size:20px;font-weight:bold;">
            Difference
          </div>
          <div style="clear:both;"></div>
        </div>
        @for (c of cashupdata; track c) {
          <div style="margin-bottom:20px;">
            <div style="float: left;">
              <button pButton pRipple type="button" style="margin-top: -8px !important;width: 40px !important;height: 40px;margin-right: 10px;" class="p-button-text p-element p-button-success w-auto mt-3" (click)="expand(c)">
                @if (!paymentList[c.index]) {
                  <span style="margin-left:-9px;" class="pi pi-angle-down"></span>
                }
                @if (paymentList[c.index]) {
                  <span style="margin-left:-9px;" class="pi pi-angle-up"></span>
                }
              </button>
            </div>
            <div style="width:20%;float: left;font-weight:bold;">
              {{c.name}}
            </div>
            <div style="width:20%;float: left;">
              {{c.paymenttotal | currency:CurrencySymbol}}
            </div>
            <div style="width:20%;float: left;">
              <p-inputnumber style="width: 130px!important; margin-top:-20px;" mode="currency" [(ngModel)]="actual[c.index]" currency="{{CurrencySymbol}}" locale="en-GB" [min]="-9999" [max]="99999" (onBlur)="CalcValue(c)"></p-inputnumber>
            </div>
            @if (variance[c.index] < 0) {
              <div style="width:20%;float: left;color: red;font-weight:bold;">
                {{variance[c.index] | currency:CurrencySymbol}}
              </div>
            }
            @if (variance[c.index] > 0) {
              <div style="width:20%;float: left;color: #18c718;font-weight:bold;">
                {{variance[c.index] | currency:CurrencySymbol}}
              </div>
            }
            @if (variance[c.index] == 0) {
              <div style="width:20%;float: left;color: black;">
                {{variance[c.index] | currency:CurrencySymbol}}
              </div>
            }
            <div style="clear:both;"></div>
            @if (paymentList[c.index]) {
              <div class="surface-card p-4 shadow-2 border-round" >
                <p-table  #paymentsTable
                  [value]="c.payments" sortField="paymentDate" [paginator]="true" [rows]="10"
                  [showCurrentPageReport]="true" responsiveLayout="scroll"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  [rowsPerPageOptions]="[10,25,50]"
                  responsiveLayout="scroll"
                  datakey="id"
                  [selectionPageOnly]="true">
                  <ng-template #header>
                    <tr>
                      <!-- <th>
                      Payment ID
                    </th> -->
                    <th pSortableColumn="paymentDate">
                      Payment Date
                    </th>
                    <th>Sales ID</th>
                    <th>Amount</th>
                    <th>Online</th>
                    <th>Refund</th>
                  </tr>
                </ng-template>
                <ng-template #body let-data>
                  <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                    <!-- <td>{{data.paymentId}}</td> -->
                    <td>{{data.paymentDate | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                    <td>{{data.bookingIdHR}}</td>
                    <td>{{data.amount | currency:CurrencySymbol}}</td>
                    @if (data.isOnline) {
                      <td><span style="color:green" class="pi pi-check"></span></td>
                    }
                    @if (!data.isOnline) {
                      <td><span style="color:red" class="pi pi-times"></span></td>
                    }
                    @if (data.isRefund) {
                      <td><span style="color:green" class="pi pi-check"></span></td>
                    }
                    @if (!data.isRefund) {
                      <td><span style="color:red" class="pi pi-times"></span></td>
                    }
                  </tr>
                </ng-template>
              </p-table>
            </div>
          }
        </div>
      }
      <hr />
      <div style="margin-bottom:20px;">
        <div style="float: left; width:50px;">
          &nbsp;
        </div>
        <div style="width:20%;float: left;font-size:20px">
          &nbsp;
        </div>
        @if (totalExpected < 0) {
          <div style="width:20%;float: left;font-size:20px;color:red">
            {{totalExpected | currency:CurrencySymbol}}
          </div>
        }
        @if (totalExpected >= 0) {
          <div style="width:20%;float: left;font-size:20px;color:black">
            {{totalExpected | currency:CurrencySymbol}}
          </div>
        }
        @if (totalActual < 0) {
          <div  style="width:20%;float: left;font-size:20px;color:red">
            {{totalActual | currency:CurrencySymbol}}
          </div>
        }
        @if (totalActual >= 0) {
          <div  style="width:20%;float: left;font-size:20px;color:black">
            {{totalActual | currency:CurrencySymbol}}
          </div>
        }
        @if (totalVariance < 0) {
          <div  style="width:20%;float: left;font-size:20px;color:red">
            {{totalVariance | currency:CurrencySymbol}}
          </div>
        }
        @if (totalVariance >= 0) {
          <div  style="width:20%;float: left;font-size:20px;color:black">
            {{totalVariance | currency:CurrencySymbol}}
          </div>
        }
        <div style="clear:both;"></div>
      </div>
      <hr />
      <div class="grid formgrid p-fluid">
        <div class="field mb-4 col-12">
          <label for="notesName" class="font-medium">Notes</label>
          <textarea pTextarea [(ngModel)]="notes" id="notesName" type="text" ></textarea>
        </div>
      </div>
      <div style="clear:both;">
        <button pButton type="button" style="height: 50px; width: 187px;margin-top:20px;" class="p-button p-button p-button-success" (click)="saveReport()">
          <span class="pi pi-save" style="margin-right:8px;"></span>
          <span>Save and Clear</span>
        </button> &nbsp;
        <button pButton type="button" style="height: 50px; width: 120px;margin-top:20px;" class="p-button p-button p-button-danger" (click)="returnHome()">
          <span class="pi pi-times" style="margin-right:8px;"></span>
          <span>Cancel</span>
        </button>
      </div>
    </div>
  }
  @if (id != '0') {
    <div class="surface-card p-4 shadow-2 border-round" style="margin-top:55px;">
      <div style="margin-bottom:20px;">
        <div style="width:20%;float: left;font-size:20px;font-weight:bold;">
          Payment Name
        </div>
        <div style="width:20%;float: left;font-size:20px;font-weight:bold;">
          Total Expected
        </div>
        <div style="width:20%;float: left;font-size:20px;font-weight:bold;">
          Total Actual
        </div>
        <div style="width:20%;float: left;font-size:20px;font-weight:bold;">
          Difference
        </div>
        <div style="clear:both;"></div>
      </div>
      @for (c of cashupdata.income; track c) {
        <div style="margin-bottom:20px;">
          <div style="width:20%;float: left;font-weight:bold;">
            {{c.method}}
          </div>
          <div style="width:20%;float: left;">
            {{c.expected | currency:CurrencySymbol}}
          </div>
          <div style="width:20%;float: left;">
            {{c.actual | currency:CurrencySymbol}}
          </div>
          @if (c.variance < 0) {
            <div style="width:20%;float: left;color: red;font-weight:bold;">
              {{c.variance | currency:CurrencySymbol}}
            </div>
          }
          @if (c.variance > 0) {
            <div style="width:20%;float: left;color: #18c718;font-weight:bold;">
              {{c.variance  | currency:CurrencySymbol}}
            </div>
          }
          @if (c.variance == 0) {
            <div style="width:20%;float: left;color: black;">
              {{c.variance  | currency:CurrencySymbol}}
            </div>
          }
          <div style="clear:both;"></div>
        </div>
      }
      <hr />
      <div style="margin-bottom:20px;">
        <div style="width:20%;float: left;font-size:20px">
          &nbsp;
        </div>
        @if (totalExpected < 0) {
          <div style="width:20%;float: left;font-size:20px;color:red">
            {{totalExpected | currency:CurrencySymbol}}
          </div>
        }
        @if (totalExpected >= 0) {
          <div style="width:20%;float: left;font-size:20px;color:black">
            {{totalExpected | currency:CurrencySymbol}}
          </div>
        }
        @if (totalActual < 0) {
          <div  style="width:20%;float: left;font-size:20px;color:red">
            {{totalActual | currency:CurrencySymbol}}
          </div>
        }
        @if (totalActual >= 0) {
          <div  style="width:20%;float: left;font-size:20px;color:black">
            {{totalActual | currency:CurrencySymbol}}
          </div>
        }
        @if (totalVariance < 0) {
          <div  style="width:20%;float: left;font-size:20px;color:red">
            {{totalVariance | currency:CurrencySymbol}}
          </div>
        }
        @if (totalVariance >= 0) {
          <div  style="width:20%;float: left;font-size:20px;color:black">
            {{totalVariance | currency:CurrencySymbol}}
          </div>
        }
        <div style="clear:both;"></div>
      </div>
      <hr />
      <div class="grid formgrid p-fluid">
        <div class="field mb-4 col-12">
          <label for="notesName" class="font-medium">Notes:</label>
          {{notes == null? "No notes" : notes}}
        </div>
      </div>
      <div style="clear:both;" style="margin-bottom: 20px;">
        <button pButton type="button" style="height: 50px; width: 180px;margin-top:20px;" class="p-button p-button p-button-danger" (click)="returnHome()">
          <span class="pi pi-chevron-left" style="margin-right:8px;"></span>
          <span>Back to list</span>
        </button>
        &nbsp;
        <button pButton type="button" class="p-button p-element p-ripple p-button-warn p-button p-component" style="background-color: yellow o !important;" (click)="generatePDF();">
          <span class="pi pi-print" style="margin-right:8px;"></span>
          <span>Print</span>
        </button>
        &nbsp;
        @if (!showData) {
          <button pButton type="button" style="height: 50px; width: 390px;margin-top:20px;" class="p-button p-button p-button-success" (click)="toggle()">
            <span class="pi pi-eye" style="margin-right:8px;"></span>
            <span>Show the data that makes up this report.</span>
          </button>
        }
        @if (showData) {
          <button pButton type="button" style="height: 50px; width: 390px;margin-top:20px;" class="p-button p-button p-button-success" (click)="toggle()">
            <span class="pi pi-eye-slash" style="margin-right:8px;"></span>
            <span>Hide the data that makes up this report.</span>
          </button>
        }
      </div>
      @if (showData) {
        <div>
          <p-table  #allPaymentsTable
            [columns]="cols"
            [value]="allPayments" sortMode="multiple" [multiSortMeta]="[{field:'method',order:1},{field:'paymentDate',order:1}]" [paginator]="true" [rows]="10"
            [showCurrentPageReport]="true" responsiveLayout="scroll"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            [rowsPerPageOptions]="[10,25,50]"
            responsiveLayout="scroll"
            datakey="id"
            [selectionPageOnly]="true">
            <ng-template #caption>
              <div class="flex">
                <button
                  type="button"
                  pButton
                  pRipple
                  (click)="allPaymentsTable.exportCSV()"
                  class="mr-2"
                  pTooltip="Export to CSV"
                  tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-excel" aria-hidden="true"></span></button>
                </div>
              </ng-template>
              <ng-template #header>
                <tr>
                  <!-- <th>Payment ID</th> -->
                  <th pSortableColumn="method">Payment Type <p-sorticon field="method"></p-sorticon></th>
                  <th pSortableColumn="paymentDate">Payment Date <p-sorticon field="paymentDate"></p-sorticon></th>
                  <th>Sales ID</th>
                  <th>Amount</th>
                  <th>Online</th>
                  <th>Refund</th>
                  <th>Refund Reason</th>
                  <th>Notes</th>
                </tr>
              </ng-template>
              <ng-template #body let-data>
                <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                  <!-- <td>{{data.paymentId}}</td> -->
                  <td>{{data.method}}</td>
                  <td>{{data.paymentDate | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                  <td>{{data.bookingIdHR}}</td>
                  <td>{{data.amount | currency:CurrencySymbol}}</td>
                  <td>{{data.isOnline}}</td>
                  <td>{{data.isRefund}}</td>
                  <td>{{data.refundreason}}</td>
                  <td>{{data.notes}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
      </div>
    }
    <div id="contentToConvert" style="position:absolute; left: -20000px">
      <div style="font-size:15px;padding:5px;">Cash up (printed: {{ today | date:'dd/MM/yyyy HH:mm' }})</div>
      <div style="font-size:15px;padding:5px;">Cash up Date: {{cashupdata.datetime | date:'dd/MM/yyyy HH:mm'}}</div>
      <div style="width:49%;float: left;font-size:15px;font-weight:bold;text-align: right;padding:5px;">
        User:
      </div>
      <div style="width:49%;float: left;font-size:15px;padding:5px;text-align: right;">
        {{loggedinUser}}
      </div>
      <div style="clear:both;"></div>
      @for (c of cashupdata.income; track c) {
        <div style="margin-bottom:20px;">
          <div style="width:49%;float: left;font-size:15px;font-weight:bold;text-align: right;padding:5px;">
            Type:
          </div>
          <div style="width:49%;float: left;font-size:15px;padding:5px;text-align: right;">
            {{c.method}}
          </div>
          <div style="clear:both;"></div>
          <div style="width:49%;float: left;font-size:15px;font-weight:bold;text-align: right;padding:5px;">
            Expected:
          </div>
          <div style="width:49%;float: left;font-size:15px;text-align: right;padding:5px;">
            {{c.expected | currency:CurrencySymbol}}
          </div>
          <div style="clear:both;"></div>
          <div style="width:49%;float: left;font-size:15px;font-weight:bold;text-align: right;padding:5px;">
            Actual:
          </div>
          <div style="width:49%;float: left;font-size:15px;text-align: right;padding:5px;">
            {{c.actual | currency:CurrencySymbol}}
          </div>
          <div style="clear:both;"></div>
          <div style="width:49%;float: left;font-size:15px;font-weight:bold;text-align: right;padding:5px;">
            Difference:
          </div>
          <div style="width:49%;float: left;font-size:15px;text-align: right;padding:5px;">
            {{c.variance  | currency:CurrencySymbol}}
          </div>
          <div style="clear:both;"></div>
        </div>
      }
      <hr />
      <div style="width:49%;float: left;font-size:15px;font-weight:bold;text-align: right;padding:5px;">
        Total Expected:
      </div>
      <div  style="width:49%;float: left;font-size:15px;text-align: right;padding:5px;">
        {{totalExpected | currency:CurrencySymbol}}
      </div>
      <div style="clear:both;"></div>
      <div style="width:49%;float: left;font-size:15px;font-weight:bold;text-align: right;padding:5px;">
        Total Actual:
      </div>
      <div  style="width:49%;float: left;font-size:15px;text-align: right;padding:5px;">
        {{totalActual | currency:CurrencySymbol}}
      </div>
      <div style="clear:both;"></div>
      <div style="width:49%;float: left;font-size:15px;font-weight:bold;text-align: right;padding:5px;">
        Total Difference:
      </div>
      <div style="width:49%;float: left;font-size:15px;text-align: right;padding:5px;">
        {{totalVariance | currency:CurrencySymbol}}
      </div>
      <div style="clear:both;"></div>
      <hr style="padding-left:5px;"/>
      <div class="grid formgrid p-fluid">
        <div class="field mb-4 col-12">
          <label for="notesName" style="font-size:15px;padding:3px">Notes:</label>
          <div style="font-size:15px;padding:5px;margin-top:-10px;">{{notes == null? "No notes" : notes}}</div>
        </div>
      </div>
    </div>
  </div>
}

